import { createSlice } from '@reduxjs/toolkit';
import { axiosInstance } from '../Axios';
import { togglePartnerModal } from 'reducers/UiReducer';



const getAxiosConfig = (token) => ({
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

const getErrorMessage = (error) =>
  error.response && error.response.data.message
    ? error.response.data.message
    : error.message;

const PartnerReducer = createSlice({
  name: 'partner',
  initialState: {
    success: false,



    // Partner states
    partnerLoading: false,
    partnerList: [],
    partnerError: null,

    
  },
  reducers: {

 

    // Partner actions
    createPartnerRequest(state) {
      state.partnerLoading = true;
    },
    createPartnerSuccess(state, action) {
      state.partnerLoading = false;
      // state.partnerList.push(action.payload);
    },
    createPartnerFail(state, action) {
      state.partnerLoading = false;
      state.partnerError = action.payload;
    },
    updatePartnerRequest(state) {
      state.partnerLoading = true;
    },
    updatePartnerSuccess(state, action) {
      state.partnerLoading = false;

    },
    updatePartnerFail(state, action) {
      state.partnerLoading = false;
      state.partnerError = action.payload;
    },
    getPartnerListRequest(state) {
      state.partnerLoading = true;
    },
    getPartnerListSuccess(state, action) {
      state.partnerLoading = false;
      state.partnerList = action.payload;
    },
    getPartnerListFail(state, action) {
      state.partnerLoading = false;
      state.partnerError = action.payload;
    },
    deletePartnerRequest(state) {
      state.partnerLoading = true;
    },
    deletePartnerSuccess(state, action) {
      state.partnerLoading = false;

    },
    deletePartnerFail(state, action) {
      state.partnerLoading = false;
      state.partnerError = action.payload;
    },




  },
});

export const {





  
  // Partner actions
  createPartnerRequest,
  createPartnerSuccess,
  createPartnerFail,
  updatePartnerRequest,
  updatePartnerSuccess,
  updatePartnerFail,
  getPartnerListRequest,
  getPartnerListSuccess,
  getPartnerListFail,

  deletePartnerRequest,
  deletePartnerSuccess,
  deletePartnerFail,



  

} = PartnerReducer.actions;







export const createPartnerDispatch = (partnerData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(createPartnerRequest());
    const { data } = await axiosInstance.post('/User/PartnerRegister', partnerData, config);

    if (data.status === 1) {
      dispatch(createPartnerSuccess());
      dispatch(getPartnerListDispatch(partnerData, token));
      dispatch(togglePartnerModal(false));
    }
  } catch (error) {
    dispatch(
      createPartnerFail(
        error.response?.data?.message || error.message
      )
    );
  }
};

export const updatePartnerDispatch = (partnerData, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(updatePartnerRequest());
    const { data } = await axiosInstance.post(`/Partner/UpdatePartner`, partnerData, config);
    if (data.status === 1) {
      dispatch(updatePartnerSuccess());
      dispatch(getPartnerListDispatch(partnerData, token));
      dispatch(togglePartnerModal(false));
    }

  } catch (error) {
    dispatch(
      updatePartnerFail(
        error.response?.data?.message || error.message
      )
    );
  }
};



export const getPartnerListDispatch = (form, token) => async (dispatch) => {
  try {
    dispatch(getPartnerListRequest());

    const { offset = 0, recordcount = 100, fullName = '' } = form;

    const queryParams = new URLSearchParams({
      offset: offset.toString(),
      recordcount: recordcount.toString(),
      FullName: fullName
    });

    const { data } = await axiosInstance.get(
      `/Partner/GetPartnerList?${queryParams.toString()}`,
      getAxiosConfig(token)
    );

    dispatch(getPartnerListSuccess(data));
  } catch (error) {
    dispatch(getPartnerListFail(getErrorMessage(error)));
  }
};




export const deletePartnerDispatch = (PartnerId, token) => async (dispatch) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    };
    dispatch(deletePartnerRequest());
    await axiosInstance.delete(`/partner/DeletePartnerById/${PartnerId}`, config);
    dispatch(deletePartnerSuccess());
  } catch (error) {
    dispatch(
      deletePartnerFail(
        error.response?.data?.message || error.message
      )
    );
  }
};






export default PartnerReducer;
